import { TPayment } from 'modules/_common/models';
import API from 'services/api';

export const updateMarkAsPaidPayments = ({
  invoiceId,
  payload,
}: {
  invoiceId: string;
  payload: { payments: TPayment[] };
}) =>
  API.put(`/api/documents/invoices/${invoiceId}/payments`, payload).then(
    response => response?.data,
  );
